import React from 'react';

import { Glyph } from './BellGlyph.styles';

/**
 * The notifications bell of the top bar. Drawn inline and stroked in `currentColor`, so the trigger's
 * colour (rest, hover, open) carries to it.
 */
export type BellGlyphProps = {
  size?: number;
};

export const BellGlyph = ({ size = 20 }: BellGlyphProps): React.ReactElement => (
  <Glyph aria-hidden="true">
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 9.5a6 6 0 0 1 12 0c0 4.2 1.3 6.3 2.2 7.3.3.3.1.7-.3.7H4.1c-.4 0-.6-.4-.3-.7.9-1 2.2-3.1 2.2-7.3Z" />
      <path d="M9.8 20.5a2.4 2.4 0 0 0 4.4 0" />
    </svg>
  </Glyph>
);
